import React from 'react';
import { Layout, Card, Row, Col, Typography, Divider, Space } from 'antd';
import { 
    DollarOutlined, 
    TeamOutlined, 
    TrophyOutlined, 
    BarChartOutlined,
    ArrowRightOutlined,
    UnorderedListOutlined,
    PartitionOutlined,
    FieldTimeOutlined,
    FileSearchOutlined,
    TransactionOutlined,
    LineChartOutlined,
    AppstoreOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";

const { Content } = Layout;
const { Title: AntTitle, Text } = Typography;

const ReportsDashboard = () => {
    const navigate = useNavigate();

    const sections = [
        {
            title: 'Financial Performance',
            icon: <DollarOutlined style={{ color: '#52c41a' }} />,
            color: '#52c41a',
            items: [
                {
                    title: 'Sales Monthly Summary',
                    description: '12-month sales trend with graphical analytics and item-wise filtering.',
                    icon: <BarChartOutlined style={{ fontSize: 32, color: '#1890ff' }} />,
                    path: '/reports/sales-summary'
                },
                {
                    title: 'Monthly Sales Details',
                    description: 'Detailed invoice audit with member and status-based filtering.',
                    icon: <FileSearchOutlined style={{ fontSize: 32, color: '#ff4d4f' }} />,
                    path: '/reports/monthly-sales-details'
                },
                {
                    title: 'Payment Details Report',
                    description: 'Track all incoming payments with invoice links and transaction references.',
                    icon: <TransactionOutlined style={{ fontSize: 32, color: '#52c41a' }} />,
                    path: '/reports/payment-details'
                }
            ]
        },
        {
            title: 'Staff & Membership',
            icon: <TeamOutlined style={{ color: '#1890ff' }} />,
            color: '#1890ff',
            items: [
                {
                    title: 'Member List Excel Export',
                    description: 'Comprehensive export of member data with advanced search and status filters.',
                    icon: <UnorderedListOutlined style={{ fontSize: 32, color: '#722ed1' }} />,
                    path: '/reports/members-detailed'
                },
                {
                    title: 'Trainer List Excel Export',
                    description: 'Comprehensive list of trainer data including specialization and assigned members.',
                    icon: <UnorderedListOutlined style={{ fontSize: 32, color: '#eb2f96' }} />,
                    path: '/reports/trainers-detailed'
                }
            ]
        },
        {
            title: 'Inventory & Operations',
            icon: <PartitionOutlined style={{ color: '#fa8c16' }} />,
            color: '#fa8c16',
            items: [
                {
                    title: 'Inventory Master List',
                    description: 'Comprehensive inventory list and equipment reports with Excel export.',
                    icon: <PartitionOutlined style={{ fontSize: 32, color: '#13c2c2' }} />,
                    path: '/reports/inventory'
                },
                {
                    title: 'Equipment Activity Logs',
                    description: 'Track breakdowns, repairs, and service history for equipment.',
                    icon: <FieldTimeOutlined style={{ fontSize: 32, color: '#fa8c16' }} />,
                    path: '/reports/inventory-activity'
                }
            ]
        },
        {
            title: 'Product Catalog',
            icon: <AppstoreOutlined style={{ color: '#faad14' }} />,
            color: '#faad14',
            items: [
                {
                    title: 'Sales Item Directory',
                    description: 'Export sales items, packages, and membership services to Excel.',
                    icon: <DollarOutlined style={{ fontSize: 32, color: '#fa8c16' }} />,
                    path: '/reports/sales-items'
                }
            ]
        }
    ];

    return (
        <Layout style={{ minHeight: '100vh', backgroundColor: '#f0f2f5' }}>
            <Headerdiv />
            <Content style={{ padding: '40px 24px' }}>
                <div style={{ textAlign: 'center', marginBottom: 48 }}>
                    <AntTitle level={2}>
                        <BarChartOutlined style={{ marginRight: 12 }} /> 
                        Report Center
                    </AntTitle>
                    <Text type="secondary" style={{ fontSize: '16px' }}>
                        Access comprehensive analytics and detailed data exports for every area of your business.
                    </Text>
                </div>

                <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                    {sections.map((section, sIndex) => (
                        <div key={sIndex} style={{ marginBottom: 48 }}>
                            <Divider orientation="left">
                                <Space>
                                    {section.icon}
                                    <span style={{ fontSize: '18px', fontWeight: 600, color: '#262626' }}>{section.title}</span>
                                </Space>
                            </Divider>
                            <Row gutter={[24, 24]}>
                                {section.items.map((item, index) => (
                                    <Col xs={24} sm={12} lg={6} key={index}>
                                        <Card 
                                            hoverable 
                                            style={{ 
                                                height: '100%', 
                                                borderRadius: '12px',
                                                border: '1px solid #e8e8e8',
                                                display: 'flex',
                                                flexDirection: 'column'
                                            }}
                                            bodyStyle={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '24px' }}
                                            onClick={() => navigate(item.path)}
                                        >
                                            <div style={{ marginBottom: 16 }}>
                                                {item.icon}
                                            </div>
                                            <AntTitle level={5} style={{ marginBottom: 8 }}>{item.title}</AntTitle>
                                            <Text type="secondary" style={{ fontSize: '13px', lineHeight: '1.5', flex: 1 }}>
                                                {item.description}
                                            </Text>
                                            <div style={{ marginTop: 16, textAlign: 'right', color: '#1890ff' }}>
                                                <Space>
                                                    <span style={{ fontSize: '12px', fontWeight: 500 }}>View Report</span>
                                                    <ArrowRightOutlined style={{ fontSize: '12px' }} />
                                                </Space>
                                            </div>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    ))}
                </div>
            </Content>
            <Footerdiv />
        </Layout>
    );
};

export default ReportsDashboard;
